import React, { useEffect, useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import '../liveVet.scss';
import { BrandContext } from '../../../contextProviders/brandContext';
import { scrollElementIntoView } from '../../../utils/scrollUtils';

export const ConsultationScreen = ({ consultationUrl }) => {
  const {
    activeBrandContext: {
      cspConfiguration: {
        liveVetConfig: {
          [process.env.REACT_APP_ENV]: { vetChatUrl }
        }
      }
    }
  } = useContext(BrandContext);

  const iframeRef = useRef(null);
  const intervalId = useRef(null);
  useEffect(() => {
    const iframe = iframeRef.current;

    scrollElementIntoView(iframe);

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    const checkForElement = () => {
      try {
        const doc = iframe?.contentWindow?.document;
        const element = doc?.getElementById('goToDashboardButton');

        if (element) {
          clearInterval(intervalId.current);
          window.removeEventListener('beforeunload', handleBeforeUnload);
        }
      } catch (e) {
        window.addEventListener('beforeunload', handleBeforeUnload);
      }
    };

    intervalId.current = setInterval(checkForElement, 1000);

    return () => {
      clearInterval(intervalId.current);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [consultationUrl, iframeRef]);

  return (
    <div className="live-vet-consultation-screen">
      <iframe
        src={consultationUrl}
        ref={iframeRef}
        title="Live Vet Consultation"
        style={{ height: '100%', width: '100%', border: 'none' }}
        allow={`camera ${vetChatUrl}; microphone ${vetChatUrl}`}
      />
    </div>
  );
};

ConsultationScreen.propTypes = {
  consultationUrl: PropTypes.string
};
